import * as React from "react"
import "./layout.css"
import Header from "./header/header";
import Footer from "./footer/footer";
import {Helmet} from "react-helmet";
import ScrollToTop from "react-scroll-to-top";
// import { ReactComponent as MySVG } from "./../../images/arrow-up-square.svg";

if (typeof window !== "undefined") {
    require("smooth-scroll")('a[href*="#"]')
}

const Layout = ({children, isHomePage, pageName}) => (
    <main>
        <Helmet>
            <meta charSet="utf-8"/>
            <title>
                Texbond - PP Spunbonded Nonwoven Fabrics and its Articles
            </title>
        </Helmet>
        <Header isHomePage={isHomePage} pageName={pageName}/>
        <ScrollToTop
            smooth
            color="#f78b77"
            // svgPath={up}
            // component={<MySVG/>}
        />
        {children}
        <Footer/>
    </main>
)

export default Layout